const SelectBoxWrapperBase =
  'relative w-full group tracking-0.2 mt-3 text-machine2-75 stroke-machine2-75'

export const SelectBoxWrapper = `${SelectBoxWrapperBase} focus-within:text-machine4-100 focus-within:stroke-machine4-100`

export const SelectBoxWrapperDisabled = `${SelectBoxWrapperBase} pointer-events-none`

const SelectBoxLabelBase =
  'relative z-[1] whitespace-nowrap font-GoodPro bg-transparent'
export const SelectBoxLabel = `${SelectBoxLabelBase} group-hover:text-machine4-100 transition-colors`

export const SelectBoxLabelDisabled = `${SelectBoxLabelBase} pointer-events-none`

const SELECT_BOX_HEIGHT = 'h-12'

export const SelectBoxSelect = `w-full
        appearance-none
        bg-transparent
        ${SELECT_BOX_HEIGHT}
        px-[24px]
        text-machine4-100
        font-GoodPro
        font-medium
        rounded
        border
        border-machine2-75
        group-hover:border-machine4-100
        placeholder-machine4-100
        placeholder:tracking-0.2
        focus:border-machine4-100
        focus:outline-none
        focus:ring-2
        focus:ring-coffee1-100
        transition
        disabled:border-machine2-75
        disabled:bg-machine2-25
        disabled:transform-none
        disabled:transition-none
        disabled:group-hover:border-machine2-75
        `

export const SelectBoxErrorBorder =
  '!border-errorRed group-hover:!border-errorRed focus:!border-errorRed !text-errorRed'

export const SelectBoxSelectArrow = `absolute right-[24px] ${SELECT_BOX_HEIGHT} bottom-0 flex items-center`

export const SelectBoxLabelWrapper = 'absolute left-[18px] w-auto px-[6px]'

export const SelectBoxLabelBackgroundHelper =
  'absolute top-1 left-0 h-[11px] w-full bg-white'
